// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Cnwy","rootNoMargin":"styles_rootNoMargin__21sXN"};